// import { Uid } from "./Uid";
import { Message } from "./Message";
import { User, Uid } from "./User";

//userreports
export class UserReport {
  static COL = 'userreports';
  id: string = Uid.get();

  constructor(public message:Message, public byUser: User) {
  }
}
